import { render, staticRenderFns } from "./StatusList.vue?vue&type=template&id=5d92b52b&scoped=true"
import script from "./StatusList.vue?vue&type=script&lang=js"
export * from "./StatusList.vue?vue&type=script&lang=js"
import style0 from "./StatusList.vue?vue&type=style&index=0&id=5d92b52b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d92b52b",
  null
  
)

export default component.exports